var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAtom = function SvgAtom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.037 7.633c.84 1.865 2.403 4.075 4.501 6.173 2.098 2.099 4.309 3.662 6.173 4.502.934.42 1.761.65 2.433.686.672.036 1.141-.12 1.435-.415.294-.294.451-.763.415-1.435-.037-.671-.266-1.499-.686-2.432-.84-1.865-2.403-4.075-4.502-6.174-2.098-2.098-4.308-3.662-6.173-4.5-.934-.421-1.761-.65-2.433-.687-.671-.037-1.14.12-1.435.414-.294.295-.45.764-.414 1.436.036.671.266 1.498.686 2.432ZM2.552 5.244c-.044-.804.136-1.533.648-2.044.511-.512 1.24-.692 2.044-.648.804.044 1.732.312 2.717.756 1.974.888 4.262 2.516 6.41 4.665 2.15 2.148 3.778 4.436 4.666 6.41.444.986.712 1.913.756 2.718.043.804-.137 1.533-.648 2.044-.511.511-1.24.691-2.044.648-.805-.044-1.732-.312-2.718-.756-1.974-.888-4.262-2.516-6.41-4.665-2.15-2.149-3.777-4.437-4.665-6.41-.444-.986-.712-1.913-.756-2.718Z",
    fill: "url(#atom_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35 17.144c-.036.672.121 1.141.415 1.435.294.294.764.451 1.435.415.672-.037 1.5-.266 2.433-.686 1.865-.84 4.075-2.403 6.173-4.502 2.099-2.098 3.662-4.308 4.502-6.173.42-.934.65-1.76.686-2.433.036-.671-.12-1.14-.415-1.435-.294-.294-.763-.45-1.435-.414-.671.036-1.499.266-2.433.686-1.864.84-4.075 2.403-6.173 4.501-2.098 2.099-3.662 4.309-4.5 6.173-.421.934-.65 1.762-.687 2.433Zm-.042-2.76c.888-1.975 2.516-4.263 4.665-6.411 2.148-2.149 4.436-3.777 6.41-4.665.986-.444 1.913-.712 2.718-.756.804-.044 1.533.136 2.044.648.511.511.691 1.24.648 2.044-.044.804-.312 1.732-.756 2.717-.888 1.974-2.516 4.262-4.665 6.411s-4.437 3.777-6.41 4.665c-.986.444-1.914.712-2.718.756-.804.043-1.533-.137-2.044-.648-.512-.511-.692-1.24-.648-2.044.044-.805.312-1.732.756-2.718Z",
    fill: "url(#atom_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.173 12.172a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "url(#atom_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "atom_svg__a",
    x1: 3.512,
    y1: 8.583,
    x2: 8.109,
    y2: 4.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8567"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "atom_svg__b",
    x1: 2.798,
    y1: 15.433,
    x2: 14.652,
    y2: 4.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8567"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "atom_svg__c",
    x1: 10.38,
    y1: 10.53,
    x2: 11.806,
    y2: 10.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8567"
  })))));
};
export default SvgAtom;